import { Component, ReactNode } from 'react'

import { BasePrivacyType, getDefaultBasePrivacy } from '../privacy/BasicPrivacy'
import NoMotorPrivacy from '../privacy/NoMotorPrivacy'

import Modal from '../../libs/ui/modal/Modal'
import ModalNotification from '../../libs/ui/modal/ModalNotification'
import ModalWaith from "../../libs/ui/modal/ModalWaith"
import Input from '../../libs/ui/inputs/Input'

import { authFetch } from '../../libs/cookie/Cookie'

import User from '../../libs/user/User'

import { 
    EMAIL_PATTERN, NAMES_PATTERN, PHONE_NUMBER_PATTERN, STRONG_PASS_PATTERN,
    isValid 
} from '../../libs/validation/stringRegex'

import { USER_REGISTER_URL } from '../../costants'

interface RegisterProps {
    isOpen: boolean,
    callBackToggle: Function
    callBackGoToLogIn?: Function
}

interface RegisterState {
    name: string | undefined
    surname: string | undefined
    email: string | undefined
    phone: string | undefined
    pass: string | undefined
    confirmPass: string | undefined
    privacy: BasePrivacyType

    nameError: string | undefined
    surnameError: string | undefined
    emailError: string | undefined
    phoneError: string | undefined
    passError: string | undefined
    
    privacyError: string | undefined

    error: string | undefined

    waith: boolean

    esito: 'ok' | 'error' | undefined
}

const MODAL_ID = 'new_user_registration'

class ModalRegister extends Component<RegisterProps, RegisterState> {

    constructor (props: any) {
        super(props)

        this.state = this.getInitialState()

        this.setName = this.setName.bind(this)
        this.setSurname = this.setSurname.bind(this)
        this.setEmail = this.setEmail.bind(this)
        this.setPhone = this.setPhone.bind(this)
        this.setPass = this.setPass.bind(this)
        this.setConfirmPass = this.setConfirmPass.bind(this)
        this.registerUser = this.registerUser.bind(this)
        this.printError = this.printError.bind(this)
        this.getValidationError = this.getValidationError.bind(this)

        this.updatePrivacy = this.updatePrivacy.bind(this)
        this.getPrivacyFromState = this.getPrivacyFromState.bind(this)
    }

    render(): ReactNode {
        return (
            <>
                <Modal
                    title='Crea il tuo account 6sicuro'
                    buttonText='Crea un account'
                    isOpen={this.props.isOpen && !this.state.waith}
                    isSigIn={true}
                    callBackGoToLogIn={this.props.callBackGoToLogIn}
                    callBackToggle={this.props.callBackToggle}
                    callBackSendData={this.registerUser}
                    error={this.state.error}
                    id={MODAL_ID}
                >
                    <p>
                        Ehi, 6 dei nostri? Inserisci i tuoi dati e scopri tutti i vantaggi dell'area personale di 6sicuro.it.
                    </p>

                    <div className='row'>
                        <div className='col-12 col-md-6'>
                            <Input 
                                id='register-name'
                                label='Nome'
                                value={this.state.name}
                                type='text'
                                callback={this.setName}
                                regexp={NAMES_PATTERN}
                                errorDisplayMsg='Nome non valido'
                                error={this.state.nameError}
                                autoComplete='off'
                            />
                        </div>
                        <div className='col-12 col-md-6'>
                            <Input 
                                id='register-surname'
                                label='Cognome'
                                value={this.state.surname}
                                type='text'
                                callback={this.setSurname}
                                regexp={NAMES_PATTERN}
                                errorDisplayMsg='Cognome non valido'
                                error={this.state.surnameError}
                                autoComplete='off'
                            />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12 col-md-6'>
                            <Input 
                                id='register-user-email'
                                label='E-mail' 
                                name='user' 
                                value={this.state.email}
                                type='email'
                                callback={this.setEmail}
                                regexp={EMAIL_PATTERN}
                                errorDisplayMsg='Email non valida'
                                error={this.state.emailError}
                                autoComplete='off'
                            />
                        </div>
                        <div className='col-12 col-md-6'>
                            <Input 
                                id='register-phone'
                                label='Celllulare'
                                value={this.state.phone}
                                type='text'
                                callback={this.setPhone}
                                regexp={PHONE_NUMBER_PATTERN}
                                errorDisplayMsg='Telefono non valido'
                                error={this.state.phoneError}
                                autoComplete='off'
                            />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12 col-md-6'>
                            <Input 
                                id='register-pass'
                                label='Password'
                                name='password'
                                value={this.state.pass}
                                type='password'
                                callback={this.setPass}
                                regexp={STRONG_PASS_PATTERN}
                                errorDisplayMsg='Password debole'
                                error={this.state.passError}
                                autoComplete='off'
                                ingoreLostFocus={true}
                            />
                        </div>
                        <div className='col-12 col-md-6'>
                            <Input 
                                id='register-confirm-pass'
                                label='Conferma password'
                                name='password'
                                value={this.state.confirmPass}
                                type='password'
                                callback={this.setConfirmPass}
                                error={this.state.passError}
                                autoComplete='off'
                                ingoreLostFocus={true}
                            />
                        </div>
                    </div>

                    <NoMotorPrivacy 
                        id='privacy'
                        basePrivacy={this.state.privacy}
                        callback={this.updatePrivacy}
                        isLogged={false}
                        error={this.state.privacyError}
                    />
                </Modal>

                <ModalWaith isOpen={this.state.waith}/>

                <ModalNotification
                    title='Registrazione completata!'
                    isError={ (this.state.esito === 'error') }
                    isOpen={ this.state.esito !== undefined }
                    callBackToggle={ () => this.setState ({esito: undefined}) }
                >
                    {
                        (this.state.esito === 'error')
                        ? <>Ricontrolla i dati inseriti</>
                        : <>Riceverai presto un link di conferma: fai click per attivare il tuo profilo!</>
                    }
                    
                </ModalNotification>
            </>
        )
    }

    private registerUser () {
        const error = this.getValidationError()
        const waith = error === undefined

        this.printError( error, waith )

        if (waith) {

            authFetch (
                USER_REGISTER_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        email : this.state.email,
                        phone : this.state.phone,
                        name :this.state.name,
                        surname :this.state.surname,
                        password :this.state.pass,
                        privacy: this.getPrivacyFromState()
                    })
                },
                () => {}
            )
            .then ( jsonObj => {

                if (jsonObj?.success === false) {
                    this.printError ( jsonObj.error_code )
                }
                else {
                    this.setState(
                        this.getInitialState(), 
                        () => {
                            if (this.props.callBackToggle) {
                                this.props.callBackToggle (
                                    new User (jsonObj)
                                )
                            }
                        }
                    )
                }

            })
        }
    }

    private getValidationError () {
        const usrPrivacy = this.getPrivacyFromState()

        if ( !isValid ( this.state.name, NAMES_PATTERN ) ) {
            return 'NAME';
        }
        if ( !isValid ( this.state.surname, NAMES_PATTERN ) ) {
            return 'SURNAME';
        }
        if ( !isValid ( this.state.email, EMAIL_PATTERN ) ) {
            return 'EMAIL';
        }
        if ( !isValid ( this.state.phone, PHONE_NUMBER_PATTERN ) ) {
            return 'PHONE';
        }
        if ( !isValid ( this.state.pass, STRONG_PASS_PATTERN ) ) {
            return 'PASS';
        }
        if (!usrPrivacy[0].consent || !usrPrivacy[1].consent || !usrPrivacy[2].consent) {
            // uno tra ivass, cgu e generale son falsi
            return 'INFORMATIVA_E_CONDIZIONI';
        }

        return undefined
    }

    private printError (errorString: string | undefined, waith: boolean = false) {
        let recivedError: string | undefined = 'Errore generico'

        let nameErro: string | undefined = undefined
        let surnameErro: string | undefined = undefined
        let emailErro: string | undefined = undefined
        let phoneErro: string | undefined = undefined
        let passErro: string | undefined = undefined
        let privacyErro: string | undefined = undefined


        if (errorString === 'ALREADY_REGISTERED') {
            recivedError = 'Utente già registrato'
            emailErro = recivedError
        }
        else if (errorString === 'NAME') {
            recivedError = 'Nome non valido'
            nameErro = recivedError
        }
        else if (errorString === 'SURNAME') {
            recivedError = 'Cognome non valido'
            surnameErro = recivedError
        }
        else if (errorString === 'EMAIL') {
            recivedError = 'Email non valida'
            emailErro = recivedError
        }
        else if (errorString === 'PHONE') {
            recivedError = 'Cellulare non valido'
            phoneErro = recivedError
        } 
        else if (errorString === 'PASS') {
            recivedError = 'Password non valida'
            passErro = recivedError
        }
        else if (errorString === 'INFORMATIVA_E_CONDIZIONI') {
            recivedError = 'Selezionare i flag obbligatorii'
            privacyErro = 'Selezionare i flag obbligatorii'
        }

        this.setState({
            waith: waith,
            error: recivedError,
            privacyError: privacyErro,
            nameError: nameErro,
            surnameError: surnameErro,
            emailError: emailErro,
            phoneError: phoneErro,
            passError: passErro,
        }, () => {
            // scrollo al primo errore -- new_user_registration
            const modalElem = document.getElementById ( MODAL_ID )
            const section = modalElem?.querySelector( '.is-invalid' ) ?? document.getElementById( MODAL_ID )
            section?.scrollIntoView( { behavior: 'smooth', block: 'start' } )
        })
    }

    private setName (val: string | undefined) {
        this.setState ({
            name: val,
            nameError: undefined
        })
    }
    private setSurname (val: string | undefined) {
        this.setState ({
            surname: val,
            surnameError: undefined
        })
    }
    private setEmail (val: string | undefined) {
        this.setState ({
            email: val,
            emailError: undefined
        })
    }
    private setPhone (val: string | undefined) {
        this.setState ({
            phone: val,
            phoneError: undefined
        })
    }
    private setPass (val: string | undefined) {
        const passError = (val !== this.state.confirmPass) ? 'Valori differenti' : undefined

        this.setState ({
            pass: val,
            passError: passError
        })
    }
    private setConfirmPass (val: string | undefined) {
        const passError = (val !== this.state.pass) ? 'Valori differenti' : undefined

        this.setState ({
            confirmPass: val,
            passError: passError
        })
    }

    private updatePrivacy (val: BasePrivacyType) {
        const newErro = (this.state.error === 'Selezionare i flag obbligatorii')
            ? undefined
            : this.state.error

        this.setState ({
            privacy: val,
            privacyError: undefined,
            error: newErro
        })
    }
    private getPrivacyFromState () {
        return [
            {
                type: 'ivass',
                channels: [],
                consent: this.state.privacy.ivass
            },
            {
                type: 'cgu',
                channels: [],
                consent: this.state.privacy.cgu
            },
            {
                type: 'generale',
                channels: ["email","phone","whatsapp","sms"],
                consent: this.state.privacy.generale
            },
            {
                type: 'commerciale',
                channels: ["email","phone","whatsapp","sms"],
                consent: this.state.privacy.commerciale
            },
            {
                type: 'newsletter',
                channels: [],
                consent: this.state.privacy.newsletter
            },
            {
                type: 'profilazione',
                channels: [],
                consent: this.state.privacy.profilazione
            },
            {
                type: 'cessione',
                channels: ["email","phone","whatsapp","sms"],
                consent: this.state.privacy.cessione
            }
        ]
    }

    private getInitialState () {
        return {
            name: undefined,
            surname: undefined,
            email: undefined,
            phone: undefined,
            pass: undefined,
            confirmPass: undefined,
            privacy: getDefaultBasePrivacy(),
            error: undefined,
            esito: undefined,

            nameError: undefined,
            surnameError: undefined,
            emailError: undefined,
            phoneError: undefined,
            passError: undefined,

            privacyError: undefined,

            waith: false
        }
    }
}

export default ModalRegister